module.exports = __webpack_public_path__ + "img/user-hair-buns.ea75a0bb.svg";